import React from 'react';
import type { JsonStructure, JsonStructureItem } from 'react-cmdk';
import { navigate } from '@gatsbyjs/reach-router';
import { AuthContext } from '~/Root/Auth';
import { useContext } from 'react';
import Icon from '~/components/atom/Icon';

const useNavigationItems = (): JsonStructure[number] => {
  const { isDHAdmin } = useContext(AuthContext);

  const items: Array<JsonStructureItem | undefined> = [
    isDHAdmin
      ? {
          id: 'admin-accounts',
          children: '[Admin] Accounts',
          icon: () => <Icon name="users" color={{ group: 'secondary' }} />,
          onClick: () => {
            void navigate('/-/accounts');
          },
          showType: false,
          keywords: ['admin', 'accounts'],
        }
      : undefined,
    {
      id: 'dashboard',
      children: 'Dashboard',
      icon: () => <Icon name="desktop" color={{ group: 'secondary' }} />,
      onClick: () => {
        void navigate('/-/');
      },
      showType: false,
      keywords: ['home', 'start', 'dashboard'],
    },
    {
      id: 'apps',
      children: 'Apps',
      icon: () => <Icon name="copy" color={{ group: 'secondary' }} />,
      onClick: () => {
        void navigate('/-/apps');
      },
      showType: false,
    },

    {
      id: 'widget',
      children: 'Webwinkel widget',
      icon: () => <Icon name="email-sign" color={{ group: 'secondary' }} />,
      onClick: () => {
        void navigate('/-/widget');
      },
      showType: false,
      keywords: ['widget'],
    },
  ];

  return {
    heading: 'Navigeren',
    id: 'navigate',
    items: items.filter((x: any): x is JsonStructureItem => x !== undefined),
  };
};

export default useNavigationItems;
